import { Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import adminApi from "../../../../api/adminApi";
import EmailSendDialogIcon from "@entrilia/shared/icons/EmailSendDialogIcon";
import ContactsJobDialog from "./ContactsJobDialog";
import NavigateToInvitationEmailSettings from "./NavigateToInvitationEmailSettings";
import { buildInviteFinishNotification } from "./contactsJobNotifications";

interface Props {
  open: boolean;
  contactIds: string[];
  description: ReactNode;
  isResend?: boolean;
  onClose: () => void;
  onInvitationSent: () => void;
}

const SendInvitationDialog = ({ open, contactIds, description, isResend, onClose, onInvitationSent }: Props) => (
  <ContactsJobDialog
    open={open}
    onClose={onClose}
    onSubmit={onInvitationSent}
    contactIds={contactIds}
    title={isResend ? "Re-send Invitation" : "Send Invitation"}
    progressTitle={contactIds.length > 1 ? "Sending invitations..." : "Sending invitation..."}
    actionLabel="Send"
    cancelLabel="Cancel sending"
    actionColor="primary"
    actionVariant="contained"
    startJob={adminApi.sendInvitationToContacts}
    buildFinishNotification={buildInviteFinishNotification}
  >
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <EmailSendDialogIcon sx={{ width: 80, height: 80 }} />
      <Typography color="textSecondary" sx={{ textAlign: "center" }}>
        {description}
      </Typography>
      <NavigateToInvitationEmailSettings />
    </Stack>
  </ContactsJobDialog>
);

export default SendInvitationDialog;
